import CounterForm from "../../components/Forms/CounterForm/CounterForm";

export default function NewCounter() {
    return (
        <CounterForm method="POST"/>
    );
}